// src/services/pricingApi.js
export const getPricing = async (service, params) => {
    try {
      const queryString = new URLSearchParams(params).toString();
      const response = await fetch(
        `https://vcwnmz9aj0.execute-api.ap-southeast-2.amazonaws.com/Prod/pricing/${service}?${queryString}`,
        {
          headers: {
            'Content-Type': 'application/json',
          },
          mode: 'cors' // Explicitly set CORS mode
        }
      );
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      return await response.json();
    } catch (error) {
      console.error(`Error fetching ${service} pricing:`, error);
      // Return a default price instead of throwing
      return { price: null };
    }
  };